import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { useCart } from "../../context/CartContext";
import { toast } from "sonner";
import { ShoppingBag } from "lucide-react";

export default function Shop() {
  const { t, localize, fmtSAR } = useI18n();
  const { add } = useCart();
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{t("nav.shop")}</h1>
      <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 md:gap-6">
        {products.map((p) => (
          <div key={p.id} data-testid={`product-card-${p.id}`} className="group overflow-hidden rounded-2xl border border-border bg-white transition-all hover:-translate-y-1 hover:shadow-lg">
            <Link to={`/shop/${p.id}`} className="block aspect-square overflow-hidden"><img src={p.image} alt="" className="h-full w-full object-cover transition-transform group-hover:scale-110" /></Link>
            <div className="p-4">
              <Link to={`/shop/${p.id}`}><h3 className="font-bold text-slate-900">{localize(p, "name")}</h3></Link>
              <div className="mt-2 flex items-center justify-between">
                <span className="font-bold text-primary">{fmtSAR(p.price)}</span>
                <button onClick={() => { add(p); toast.success(t("common.add")); }} data-testid={`add-cart-${p.id}`} className="rounded-full bg-primary p-2 text-white transition-all hover:scale-110 active:scale-95"><ShoppingBag className="h-4 w-4" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
